"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRID_ROW_HEIGHT_IN_PX = exports.DASHBOARD_LAYOUT_MAX_HEIGHT_AS_RATIO_XS = exports.DASHBOARD_LAYOUT_VIS_TYPE = exports.DASHBOARD_LAYOUT_RESPONSIVE_SMALL_WIDTH = exports.DASHBOARD_LAYOUT_CONTAINER_WIDTHS = exports.DASHBOARD_LAYOUT_GRID_CONFIGURATION = exports.DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT = exports.SCREEN_BREAKPOINT_XXL = exports.SCREEN_BREAKPOINT_XL = exports.SCREEN_BREAKPOINT_LG = exports.SCREEN_BREAKPOINT_MD = exports.SCREEN_BREAKPOINT_SM = exports.SCREEN_BREAKPOINT_XS = exports.ALL_SCREENS = void 0;
exports.ALL_SCREENS = ["xl", "lg", "md", "sm", "xs"];
// Breakpoints
exports.SCREEN_BREAKPOINT_XS = 320;
exports.SCREEN_BREAKPOINT_SM = 640;
exports.SCREEN_BREAKPOINT_MD = 940;
exports.SCREEN_BREAKPOINT_LG = 1170;
exports.SCREEN_BREAKPOINT_XL = 1590;
exports.SCREEN_BREAKPOINT_XXL = 99999999;
// Grid configuration
exports.DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT = 12;
var DASHBOARD_LAYOUT_GUTTER_WIDTH = 0;
var DASHBOARD_LAYOUT_BREAKPOINT_XS = exports.SCREEN_BREAKPOINT_XS + 1;
var DASHBOARD_LAYOUT_BREAKPOINT_SM = exports.SCREEN_BREAKPOINT_SM + 1;
var DASHBOARD_LAYOUT_BREAKPOINT_MD = exports.SCREEN_BREAKPOINT_LG + 1;
var DASHBOARD_LAYOUT_BREAKPOINT_LG = exports.SCREEN_BREAKPOINT_XL + 1;
var DASHBOARD_LAYOUT_BREAK_POINTS = [
    DASHBOARD_LAYOUT_BREAKPOINT_XS,
    DASHBOARD_LAYOUT_BREAKPOINT_SM,
    DASHBOARD_LAYOUT_BREAKPOINT_MD,
    DASHBOARD_LAYOUT_BREAKPOINT_LG,
];
exports.DASHBOARD_LAYOUT_GRID_CONFIGURATION = {
    // https://github.com/sealninja/react-grid-system#%EF%B8%8F-upgrading-to-v7
    maxScreenClass: "xl",
    defaultScreenClass: undefined,
    gutterWidth: DASHBOARD_LAYOUT_GUTTER_WIDTH,
    breakpoints: DASHBOARD_LAYOUT_BREAK_POINTS,
};
// Default widget sizes
var DASHBOARD_LAYOUT_PADDING = 8;
// measured from '.s-fluid-layout-container' element
exports.DASHBOARD_LAYOUT_CONTAINER_WIDTHS = {
    xs: 310 - DASHBOARD_LAYOUT_PADDING,
    sm: 630 - DASHBOARD_LAYOUT_PADDING,
    md: 980 - DASHBOARD_LAYOUT_PADDING,
    lg: 1330 - DASHBOARD_LAYOUT_PADDING,
    xl: 1660 - DASHBOARD_LAYOUT_PADDING,
};
exports.DASHBOARD_LAYOUT_RESPONSIVE_SMALL_WIDTH = 180;
exports.DASHBOARD_LAYOUT_VIS_TYPE = {
    headline: "headline",
    xirr: "xirr",
    column: "column",
    bar: "bar",
    line: "line",
    area: "area",
    combo: "combo",
    combo2: "combo2",
    scatter: "scatter",
    bubble: "bubble",
    pie: "pie",
    donut: "donut",
    treemap: "treemap",
    heatmap: "heatmap",
    table: "table",
    pushpin: "pushpin",
};
exports.DASHBOARD_LAYOUT_MAX_HEIGHT_AS_RATIO_XS = 150;
exports.GRID_ROW_HEIGHT_IN_PX = 20;
//# sourceMappingURL=constants.js.map